import {DateTimeString, UserRef} from "@t/util/CommonTypes.ts";
import {FormDefinition} from "@t/fd/layout/FormDefinition.ts";
import {InterfaceRoot} from "@t/fd/InterfaceRoot.ts";

export type ForceInfoType = "fulfill-comment" | "fulfill-feedback" | "info-feedback" | "see-this" | "info-completed" | "micro-task" | "unknown";

export const ACCEPTED:number = 1;
export const DECLINED:number = 5;

export interface ForceInfo {
	id: number;
	icon?: string;
	type: ForceInfoType;
	responsible: string;
	srcType?: number;
	srcId?: number;
	/** If srcType/Id points to a row object, this property will contain name of the object (e.g. task or buscase) */
	srcName?: string;

	entered: DateTimeString;
	enteredBy?: string;
	expire?: DateTimeString;
	value?: string;

	customText?: string;
	customValue0?: string;
	customValue1?: string;
	/** If customText contain a i18n key, this property will contain localized version of bundle.getMessage(customText, customValue0, customValue1) */
	text?: string;

	customURL?: string;
	customLinkName?: string;

	/** MicroTask class */
	taskClass?: string;
	taskData?: object;
	taskForm?: InterfaceRoot<FormDefinition>;
}
